import React, { useState, useEffect, useContext } from 'react';
import WorkspaceForm from '../components/WorkspaceForm';
import { WorkspaceContext } from '../context/WorkspaceContext';
import WorkspaceServices from '../api/workspaceServices';
import '../styles/Table.css';

function Workspaces({ apiToken}) {
  const { workspaces, loading } = useContext(WorkspaceContext);
  const [list, setList] = useState([]);

  useEffect(() => {
    if (!loading) {
      setList(workspaces);  
    }
  }, [workspaces,loading]);

  const handleWorkspaceSaved = (workspaceId) => {
  };

    const handleDeleteWorkspace = async (id) => {
      await WorkspaceServices.deleteWorkspace(id);
      const l = await WorkspaceServices.listWorkspaces();
      setList(l);
    }

    const handleEditWorkspace = async (workspace) => {
      const l = await WorkspaceServices.listWorkspaces();
      setList(l);
    }
  
    const handleSelectWorkspace = (workspace) => {
      WorkspaceServices.selectWorkspace(workspace.id);
    };

    if (loading) {
      return <div>Cargando datos...</div>;
    }
  
    return (
      <div>
      <h2>Workspaces</h2>
      <WorkspaceForm onWorkspaceSaved={handleWorkspaceSaved} />
      <br/>
      <table>
        <thead>
        <tr>
          <th>Nombre</th>
          <th>Slug</th>
          <th>Acción</th>
        </tr>
        </thead>
        <tbody>
        {list.map((ws) => (
          <tr key={ws.id}>
          <td>{ws.name}</td>
          <td>{ws.slug}</td>
          <td>
            <button onClick={() => handleSelectWorkspace(ws.id)}>
              <span role="img" aria-label="select">🔍</span>
            </button>
            <button onClick={() => handleEditWorkspace(ws.id)}>
              <span role="img" aria-label="edit">✏️</span>
            </button>
            <button onClick={() => handleDeleteWorkspace(ws.id)}>
              <span role="img" aria-label="delete">🗑️</span>
            </button>
          </td>
          </tr>
        ))}
        </tbody>
      </table>
      </div>
    );
  }

export default Workspaces;
